<p class="fms-notification-title" *ngIf="title">{{ title }}</p>
<p class="fms-notification-body" *ngIf="question">{{ question }}</p>
<ul class="fms-notification-survey-choices">
  <li *ngFor="let choice of choices">
    <label class="fms-notification-survey-choice">
      <input
        [type]="allowMultiple ? 'checkbox' : 'radio'"
        [checked]="isSelected(choice)"
        (change)="toggle(choice)"
      />
      <span>{{ choice.label }}</span>
    </label>
  </li>
</ul>
<button vng-button size="sm" variant="primary" type="button" [disabled]="!canSubmit" (click)="submit()">
  Submit
</button>
